import { createAction } from 'redux-actions';
import {
  REQUEST_PROFILE_SUCCESS,
  REQUEST_PROFILE_FAILURE,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_PROFILE_FAILURE
} from '../constants/actionTypes';
import * as Profile from '../api/profile';
import { showErrorSnackbar, showSuccessSnackbar } from './snackbar';

const requestProfileSuccess = createAction(REQUEST_PROFILE_SUCCESS);
const requestProfileFailure = createAction(REQUEST_PROFILE_FAILURE);

export function requestProfile(params) {
  return dispatch => Profile.requestProfile(params)
    .then(({ data }) => dispatch(requestProfileSuccess(data)))
    .catch(error =>{ 

      if(error?.response?.status === 401){
        dispatch(showErrorSnackbar('Session is Expired!!!'));
      }
      dispatch(requestProfileFailure(error))});
}

const updateProfileSuccess = createAction(UPDATE_PROFILE_SUCCESS);
const updateProfileFailure = createAction(UPDATE_PROFILE_FAILURE);

export function updateProfile(params) {
  return dispatch => Profile.updateProfile(params)
    .then(({ data }) => {
      dispatch(showSuccessSnackbar('Profile updated successfully'));
      return dispatch(updateProfileSuccess(data));
    })
    .catch((error) => {
      dispatch(showErrorSnackbar('Profile update failed'));
      return dispatch(updateProfileFailure(error));
    });
}
